/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowCollapseTrianglesVOpenIcon16Light } from './ArrowCollapseTrianglesVOpenIcon16Light';
import { ArrowCollapseTrianglesVOpenIcon16Regular } from './ArrowCollapseTrianglesVOpenIcon16Regular';
import { ArrowCollapseTrianglesVOpenIcon16Solid } from './ArrowCollapseTrianglesVOpenIcon16Solid';
import { ArrowCollapseTrianglesVOpenIcon20Light } from './ArrowCollapseTrianglesVOpenIcon20Light';
import { ArrowCollapseTrianglesVOpenIcon20Regular } from './ArrowCollapseTrianglesVOpenIcon20Regular';
import { ArrowCollapseTrianglesVOpenIcon20Solid } from './ArrowCollapseTrianglesVOpenIcon20Solid';
import { ArrowCollapseTrianglesVOpenIcon24Regular } from './ArrowCollapseTrianglesVOpenIcon24Regular';
import { ArrowCollapseTrianglesVOpenIcon24Solid } from './ArrowCollapseTrianglesVOpenIcon24Solid';
import { ArrowCollapseTrianglesVOpenIcon32Regular } from './ArrowCollapseTrianglesVOpenIcon32Regular';
import { ArrowCollapseTrianglesVOpenIcon64Regular } from './ArrowCollapseTrianglesVOpenIcon64Regular';
var sizes = {
    16: {
        light: ArrowCollapseTrianglesVOpenIcon16Light,
        regular: ArrowCollapseTrianglesVOpenIcon16Regular,
        solid: ArrowCollapseTrianglesVOpenIcon16Solid,
    },
    20: {
        light: ArrowCollapseTrianglesVOpenIcon20Light,
        regular: ArrowCollapseTrianglesVOpenIcon20Regular,
        solid: ArrowCollapseTrianglesVOpenIcon20Solid,
    },
    24: {
        regular: ArrowCollapseTrianglesVOpenIcon24Regular,
        solid: ArrowCollapseTrianglesVOpenIcon24Solid,
    },
    32: {
        regular: ArrowCollapseTrianglesVOpenIcon32Regular,
    },
    64: {
        regular: ArrowCollapseTrianglesVOpenIcon64Regular,
    },
};
export var ArrowCollapseTrianglesVOpenIcon = forwardRef('ArrowCollapseTrianglesVOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
